var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgWuliu = function SvgWuliu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.358 15.5h-.625a2.5 2.5 0 11-5 0h-6.25a2.5 2.5 0 11-5 0h-.625a.625.625 0 01-.625-.625V5.5a2.5 2.5 0 012.5-2.5h6.25a2.5 2.5 0 012.5 2.5h3.087a.64.64 0 01.513.18l3.68 3.68c.018.018.012.046.028.066a.622.622 0 01.192.449v5c0 .345-.28.625-.625.625zM4.983 14.25a1.25 1.25 0 10.001 2.5 1.25 1.25 0 000-2.5zm11.25 2.5a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zm-1.25-10h-2.5v3.75h6.25l-3.75-3.75z",
    fill: "#F75C2F"
  })));
};

export default SvgWuliu;